import { Formik } from "formik";
import React, { ReactElement } from "react";
import * as yup from "yup";
import { resetPassword } from "../../libs/apiHelpers/auth";
import { withApiErrors } from "../../libs/apiHelpers/errorHandlers";
import { reachGoal } from "../../libs/helpers/metrics";
import Form from "./Form";
import Input from "./Input";
import SubmitButton from "./SubmitButton";

enum Fields {
  email = "email",
  password = "password"
}

interface Props {
  onSubmit?: Function;
}

export default function ResetPassword({ onSubmit }: Props): ReactElement {
  const initialValues = {
    [Fields.email]: ""
  };
  const validationSchema = yup.object({
    [Fields.email]: yup.string().email("Enter a valid email").required("Email is required")
  });
  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={(values, helpers) => {
        const { email } = values;
        return resetPassword(email)
          .then(() => {
            reachGoal("Submit_Reset_Password");
            onSubmit && onSubmit();
          })
          .catch(withApiErrors({ errorTitle: "Reset password error", fieldsList: Object.keys(values), helpers }));
      }}>
      <Form>
        <Input
          name={Fields.email}
          type="email"
          placeholder="Email address"
          comment="We will send a letter on this email with details on further actions"
        />
        <SubmitButton variant="primary">Request reset</SubmitButton>
      </Form>
    </Formik>
  );
}
